import React, { useEffect, useState } from "react";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { FC } from "react";

export interface GuestsObject {
  guestAdults?: number;
  guestChildren?: number;
  guestInfants?: number;
  pets?: number;
}

export interface GuestsInputProps {
  defaultValue: GuestsObject;
  onChange?: (data: GuestsObject) => void;
  className?: string;
}

const GuestsInput: FC<GuestsInputProps> = ({
  defaultValue,
  onChange,
  className = "",
}) => {
  const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(
    defaultValue.guestAdults || 0
  );
  const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(
    defaultValue.guestChildren || 0
  );
  const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(
    defaultValue.guestInfants || 0
  );
  const [petsInputValue, setPetsInputValue] = useState(defaultValue.pets || 0);

  useEffect(() => {
    setGuestAdultsInputValue(defaultValue.guestAdults || 0);
  }, [defaultValue.guestAdults]);
  useEffect(() => {
    setGuestChildrenInputValue(defaultValue.guestChildren || 0);
  }, [defaultValue.guestChildren]);
  useEffect(() => {
    setGuestInfantsInputValue(defaultValue.guestInfants || 0);
  }, [defaultValue.guestInfants]);
  useEffect(() => {
    setPetsInputValue(defaultValue.pets || 0);
  }, [defaultValue.pets]);

  const handleChangeData = (value: number, type: keyof GuestsObject) => {
    let newValue = {
      guestAdults: guestAdultsInputValue,
      guestChildren: guestChildrenInputValue,
      guestInfants: guestInfantsInputValue,
      pets: petsInputValue,
    };
    
    if (type === "guestAdults") {
      setGuestAdultsInputValue(value);
      newValue.guestAdults = value;
    }
    if (type === "guestChildren") {
      setGuestChildrenInputValue(value);
      newValue.guestChildren = value;
    }
    if (type === "guestInfants") {
      setGuestInfantsInputValue(value);
      newValue.guestInfants = value;
    }
    if (type === "pets") {
      setPetsInputValue(value);
      newValue.pets = value;
    }
    onChange && onChange(newValue);
  };

  return (
    <div className={`flex flex-col relative p-5 ${className}`}>
      <span className="mb-5 block font-semibold text-xl sm:text-2xl">
        Who's coming?
      </span>
      <NcInputNumber
        className="w-full"
        defaultValue={guestAdultsInputValue}
        onChange={(value) => handleChangeData(value, "guestAdults")}
        max={20}
        label="Adults"
        desc="Ages 13 or above"
      />
      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guestChildrenInputValue}
        onChange={(value) => handleChangeData(value, "guestChildren")}
        max={20}
        label="Children"
        desc="Ages 2–12"
      />

      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guestInfantsInputValue}
        onChange={(value) => handleChangeData(value, "guestInfants")}
        max={20}
        label="Infants"
        desc="Ages 0–2"
      />

      <NcInputNumber
        className="w-full mt-6"
        defaultValue={petsInputValue}
        onChange={(value) => handleChangeData(value, "pets")}
        max={20}
        label="Pets"
        desc="Number of pets"
      />
    </div>
  );
};

export default GuestsInput;
